import { useScrollAnimationMultiple } from "@/hooks/useScrollAnimation";

const stats = [
  { icon: "ri-calendar-check-fill", value: "Since 2016", label: "Established", desc: "Trusted real estate developer in Bengaluru" },
  { icon: "ri-building-4-fill", value: "7+", label: "Completed Projects", desc: "Successfully delivered layouts on Sarjapur Road" },
  { icon: "ri-loader-4-fill", value: "2", label: "Ongoing Projects", desc: "Amber Park & Urban Palms — book now" },
  { icon: "ri-home-heart-fill", value: "Trusted", label: "By Home Buyers", desc: "Hundreds of families have invested with us" },
];

export default function TrustStats() {
  const { setRef, visibleItems } = useScrollAnimationMultiple(stats.length);

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              ref={setRef(i) as (el: HTMLDivElement | null) => void}
              className={`card-hover group bg-white border border-gray-100 rounded-2xl p-6 text-center reveal reveal-delay-${i + 1} ${visibleItems[i] ? "visible" : ""}`}
              style={{ borderTop: "3px solid #7FBF3F" }}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#EAF5E1] rounded-full mx-auto mb-3 group-hover:bg-[#1B2A4A] transition-colors duration-300">
                <i className={`${stat.icon} text-xl text-[#7FBF3F] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-[#1B2A4A] mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{stat.value}</div>
              <div className="text-sm font-semibold text-[#212121] mb-1" style={{ fontFamily: "'Poppins', sans-serif" }}>{stat.label}</div>
              <div className="text-xs text-gray-500">{stat.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
